<script setup lang="ts">
import { useQuasar } from 'quasar';
// set Dark Mode to auto
const $q = useQuasar();
//
$q.dark.set('auto');
//
// console.log(`App.vue-process.env.DEV=[${process.env.DEV}]!`);
// console.log(`App.vue-process.env.PROD=[${process.env.PROD}]!`);
//
</script>

<template>
  <router-view></router-view>
</template>
